import { pb } from "@/utils/PocketBaseAdapter";

/**
 * Marks any event tickets already linked to a docket's "Event" docketLines as paid.
 * Call this whenever a docket becomes fully paid, from ANY payment-completion path
 * (POS payment, "mark docket as paid", online pay-by-link, etc.) - it only touches
 * tickets that already exist (eg. pre-created unpaid by a webshop "pay in store"
 * purchase). Creating new tickets is handled server-side by pb_hooks/events_helper.js.
 */
export const markEventTicketsPaidForDocket = async (docketId: string): Promise<void> => {
  const docketLineItems = await pb.collection("docketLines").getFullList({
    filter: `docket="${docketId}"`,
    requestKey: null,
  });

  const eventTicketIds = (docketLineItems as any[])
    .filter((item: any) => item?.transactionType === "Event" && item?.eventTicket?.length)
    .flatMap((item: any) => item.eventTicket);

  if (!eventTicketIds.length) return;

  const ticketsFilter = eventTicketIds.map((id: string) => `id="${id}"`).join(" || ");
  const linkedTickets = await pb.collection("eventTickets").getFullList({
    filter: ticketsFilter,
    requestKey: null,
  });

  const unpaidTickets = linkedTickets.filter(
    (ticket: any) => ticket.due > 0 || !ticket.paid
  );

  await Promise.all(
    unpaidTickets.map((ticket: any) =>
      pb.collection("eventTickets").update(ticket.id, {
        paid: true,
        due: 0,
      })
    )
  );
};
